<nav
  class="navbar navbar-expand-lg bg-body-tertiary fixed-top"
>
  <div class="container-fluid">
    <a class="navbar-brand d-inline-block" href="#">
      <img [src]="logoImage()" style="max-height: 32px" alt="Company Logo" />
    </a>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" href="#">
            <app-icons name="bell" [width]="24" [height]="24"></app-icons>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">
            <app-icons name="helpCircle" [width]="24" [height]="24"></app-icons>
          </a>
        </li>
        <li class="nav-item">
          <div class="nav-link">
            <div class="vr"></div>
          </div>
        </li>

        <li class="nav-item dropdown">
          <div class="btn-group nav-link user-dropdown" ngbDropdown>
            <div class="dropdown-toggle" type="button" ngbDropdownToggle>
              <div class="d-flex align-items-center gap-3">
                <div class="d-flex align-items-end flex-column">
                  <p class="user-name">{{ username() | titlecase }}</p>
                  <p class="user-role">{{ userType() | titlecase }}</p>
                </div>
                <div class="user-img">
                  <img [src]="userImage()" alt="" />
                </div>
              </div>
            </div>
            <ul
              ngbDropdownMenu
              class="dropdown-menu dropdown-menu-lg dropdown-menu-right mt-2"
            >
              <li>
                <div class="user-dropdown-item rounded-bottom-0 px-0">
                  <div ngbDropdownItem class="item-container">
                    <a href="#" class="sub-items">
                      <app-icons
                        name="profile"
                        [width]="20"
                        [height]="20"
                        color="#717680"
                      ></app-icons>
                      <p>Profile</p>
                    </a>
                    <div class="badge">Ctrl+P</div>
                  </div>
                  <div ngbDropdownItem class="item-container">
                    <a  routerLink="/profile/change-password" class="sub-items">
                      <app-icons
                        name="lock"
                        [width]="20"
                        [height]="20"
                        color="#717680"
                      ></app-icons>
                      <p>Change password</p>
                    </a>
                    <div class="badge">Ctrl+Del</div>
                  </div>
                  <div ngbDropdownItem class="item-container">
                    <a href="#" class="sub-items">
                      <app-icons
                        name="help"
                        [width]="20"
                        [height]="20"
                        color="#717680"
                      ></app-icons>
                      <p>Help</p>
                    </a>
                  </div>
                  <div ngbDropdownItem class="item-container">
                    <a href="#" class="sub-items">
                      <app-icons
                        name="support"
                        [width]="20"
                        [height]="20"
                        color="#717680"
                      ></app-icons>
                      <p>Support</p>
                    </a>
                    <div class="badge">F1</div>
                  </div>
                </div>
              </li>
              <li>
                <div class="user-dropdown-item rounded-top-0">
                  <p class="switch-acc">Switch Account</p>
                  <div
                    ngbDropdownItem
                    class="item-container switch-user active"
                  >
                    <div class="sub-items">
                      <div class="user-img">
                        <img src="assets/images/user.png" alt="" />
                      </div>
                      <div class="d-flex align-items-start flex-column">
                        <p class="user-name">Alex William</p>
                        <p class="user-role">Agent</p>
                      </div>
                    </div>
                    <span class="custom-radio">
                      <span class="radio-circle checked" id="user1"></span>
                    </span>
                  </div>
                  <div ngbDropdownItem class="item-container switch-user">
                    <div class="sub-items">
                      <div class="user-img">
                        <img src="assets/images/user2.png" alt="" />
                      </div>
                      <div class="d-flex align-items-start flex-column">
                        <p class="user-name">Frances Swann</p>
                        <p class="user-role">Admin</p>
                      </div>
                    </div>
                    <span class="custom-radio">
                      <span class="radio-circle" id="user2"></span>
                    </span>
                  </div>
                  <div ngbDropdownItem class="item-container switch-user">
                    <div class="sub-items">
                      <div class="user-img">
                        <img src="assets/images/user3.png" alt="" />
                      </div>
                      <div class="d-flex align-items-start flex-column">
                        <p class="user-name">Autumn Phillips</p>
                        <p class="user-role">QA Verifier</p>
                      </div>
                    </div>
                    <span class="custom-radio">
                      <span class="radio-circle" id="user3"></span>
                    </span>
                  </div>
                </div>
              </li>
              <li>
                <div ngbDropdownItem class="item-container p-3">
                  <a
                    href="javascript:void(0)"
                    class="logout-btn sub-items"
                    (click)="onLogout()"
                  >
                    <app-icons
                      name="logout"
                      [width]="24"
                      [height]="24"
                      color="#D03F5F"
                    ></app-icons>
                    Logout
                  </a>
                  <div class="badge">Ctrl+Q</div>
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
